import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/accaBonusMessageHeader.css'
import {OPERATOR} from "../../../../../constants/operator";
import {getText} from '../../../../../helpers/localization';
import {ENABLED} from "../../../../../constants/identifiers";

const mapStateToProps = (state, ownProps) => {
    return {
        openBetsList: state.vpp.openBetsList,
        games: state.vpp.games
    };
};

class AccaBonusMessageHeader extends Component {
    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();
        this.state = {
            openBetsList: storeData.vpp.openBetsList,
            games: storeData.vpp.games
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        if (nextProps && storeData) {
            this.setState({
                openBetsList: storeData.vpp.openBetsList,
                games: storeData.vpp.games
            });
        }
    }

    render() {
        let accabetBonusInfo = '';
        if (OPERATOR.accaBoostBonusEnabled && this.props.betSelection) {
            if (this.state.games.find(g => g.channel === this.props.betSelection.bets[0].game.channel).state.toString() == ENABLED && !this.props.betSelection.bets[0].hasExpired) {

                let singleBets = this.props.openBetsList.filter((oBet) => oBet.bets.length === 1
                    && oBet.bets[0].event.channel === this.props.betSelection.bets[0].event.channel
                    && oBet.bets[0].event.leagueDay === this.props.betSelection.bets[0].event.leagueDay);
                let isAccaMoreThan8Bet = singleBets != undefined && singleBets.length > 8 ? true : false;
                let containsInvalidAccaBets = new Set(this.props.betSelection.bets.map(b => b.event.eventId)).size !== this.props.betSelection.bets.length;
                let containsInvalidSingleBets = new Set(singleBets.map(b => b.bets[0].event.eventId)).size !== singleBets.length;

                if (OPERATOR.accaBoostBonusEnabled && !isAccaMoreThan8Bet && !containsInvalidSingleBets && !containsInvalidAccaBets) {
                    let bonusLevels = Object.keys(JSON.parse(OPERATOR.accaBoostBonusPercentage)).sort(function (a, b) {
                        return Number(a) - Number(b);
                    });
                    let bonusPercentage = JSON.parse(OPERATOR.accaBoostBonusPercentage)[this.props.betSelection.bets.length];
                    let higherbonus = bonusLevels.find((i) => {
                        return this.props.betSelection.bets.length < Number(i)
                    });
                    if (bonusPercentage) {
                        accabetBonusInfo = higherbonus ? <div
                                className={style.accaBoostInfo}>{getText('BOOST_BONUS_UPGRADE', this.props.store)}</div>
                            : <div className={style.accaBoostInfo}>{getText('BOOST_BONUS_MAX', this.props.store)}</div>;
                    } else {
                        accabetBonusInfo = higherbonus ? <div
                            className={style.accaBoostInfo}>{getText('BOOST_BONUS_START', this.props.store, [higherbonus])}</div> : '';
                    }
                }
            }
        }
        return accabetBonusInfo;
    }
}

export default connect(mapStateToProps)(AccaBonusMessageHeader);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/accaBonusMessageHeader.js